const suffixes = ['', 'k', 'M', 'B', 'T', ''];
const isNumber = (value) => {
    return typeof value === 'number' && !Number.isNaN(value);
};
export const abbreviateNumber = (value) => {
    if (!value || (value < 1 && value > -1)) {
        return isNumber(value) ? value.toString() : null;
    }
    const tier = Math.floor(Math.log(Math.abs(value)) / Math.log(1000));
    const suffix = suffixes[Math.min(tier, suffixes.length)];
    const adjusted = String(Math.abs(value) / Math.pow(1000, tier)).substring(0, 3);
    const noTrailingDec = adjusted.endsWith('.')
        ? adjusted.slice(0, -1)
        : adjusted;
    return `${value < 0 ? '-' : ''}${noTrailingDec}${suffix}`;
};
//# sourceMappingURL=abbreviateNumber.js.map
// @zapier/universal-layout@12.0.37 (fb08e5a7f)
